import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { I18nProvider, DEFAULT_LANG, SUPPORTED_LANGS, getLangFromPathname } from "@/i18n/I18nProvider";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import CookieBanner, { useCookieBanner } from "@/components/CookieBanner";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import ThankYou from "@/pages/ThankYou";

function AppShell({ children }) {
  const location = useLocation();
  const cookie = useCookieBanner();
  const isThankYou = location.pathname === "/thank_you";

  return (
    <div className="flex min-h-screen flex-col" style={{ backgroundColor: "#FAF8F5" }}>
      {!isThankYou && <Header />}
      <div className="flex-1">{children}</div>
      {!isThankYou && <Footer onManageCookies={() => cookie.setOpenSettings(true)} />}
      <CookieBanner
        openBanner={cookie.openBanner}
        setOpenBanner={cookie.setOpenBanner}
        openSettings={cookie.openSettings}
        setOpenSettings={cookie.setOpenSettings}
      />
    </div>
  );
}

function RootRedirect() {
  return <Navigate to={`/${DEFAULT_LANG}`} replace />;
}

function UnknownLangRedirect() {
  // If the URL uses an unsupported language segment, fall back to the default one.
  const location = useLocation();
  const first = location.pathname.split("/").filter(Boolean)[0];
  if (SUPPORTED_LANGS.includes(first)) return null;
  return <Navigate to={`/${DEFAULT_LANG}`} replace />;
}

function LanguageRoutes() {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/thank_you" element={<ThankYou />} />
      {SUPPORTED_LANGS.map((lang) => (
        <Route key={lang} path={`/${lang}`}>
          <Route index element={<Home />} />
          <Route
            path="privacy"
            element={<LegalPage namespace="privacy" testId="privacy-page" />}
          />
          <Route
            path="cookie"
            element={<LegalPage namespace="cookie" testId="cookie-page" />}
          />
          <Route
            path="terms"
            element={<LegalPage namespace="terms" testId="terms-page" />}
          />
        </Route>
      ))}
      <Route path="*" element={<UnknownLangRedirect />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
        <ScrollToTop />
        <AppShell>
          <LanguageRoutes />
        </AppShell>
      </I18nProvider>
    </BrowserRouter>
  );
}

// Suppress unused import warning
void getLangFromPathname;
